import { render, staticRenderFns } from "./ProjectPeriods.vue?vue&type=template&id=a2b418f6"
import script from "./ProjectPeriods.vue?vue&type=script&lang=js"
export * from "./ProjectPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports